import styled from '@emotion/styled';
import { Dropdown, Flex, Menu, type MenuProps } from 'antd';
import type { FC, ReactNode } from 'react';
import { AccountInfo } from '../BasicComponents/AccountInfo/AccountInfo';

type Props = {
  isCollapsed: boolean;
  items: NonNullable<MenuProps['items']>;
  collapsedItems?: NonNullable<MenuProps['items']>;
  costCalcModal: ReactNode;
};

export const UserLinks: FC<Props> = ({ isCollapsed, items, collapsedItems, costCalcModal }) => {
  if (items.length === 0) return null;

  if (isCollapsed) {
    return (
      <Flex vertical>
        <Menu items={collapsedItems ?? items} mode="vertical" />
        {costCalcModal}
      </Flex>
    );
  }

  return (
    <>
      <Dropdown menu={{ items }} trigger={['click']} className="nav-dropdown-user">
        <UserButton id="user" type="button">
          <AccountInfo />
        </UserButton>
      </Dropdown>
      {costCalcModal}
    </>
  );
};

const UserButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
`;
